// Modelo de los datos de un hotel
export default class Hotels {
    constructor (
         public id: number = null,
         public hotelName: string = '',
    ) {

    }
}
